/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Select_Next_Event_HelpInputs */



/**
* | output |
* | --- |
* | "Automatically select the next event when the start timecode is updated." |
*
* @param {Options_Editor_Auto_Select_Next_Event_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_select_next_event_help = /** @type {((inputs?: Options_Editor_Auto_Select_Next_Event_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Select_Next_Event_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner automatiquement l'événement suivant lorsque le code temporel de début est mis à jour.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das nächste Ereignis wird automatisch ausgewählt, sobald der Startzeitcode aktualisiert wird.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona automaticamente l'evento successivo quando il timecode di inizio viene aggiornato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматический выбор следующего события при обновлении временного кода начала.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar automáticamente el próximo evento cuando se actualiza el código de tiempo de inicio.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("当开始时间码更新时，自动选择下一个事件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始タイムコードが更新されると、次のイベントが自動的に選択されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रारंभ समय कोड अपडेट होने पर अगले इवेंट का स्वचालित रूप से चयन करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecionar automaticamente o próximo evento quando o código de tempo inicial for atualizado.")
	return /** @type {LocalizedString} */ ("Automatically select the next event when the start timecode is updated.")
});